
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en/translation.json";
import ko from "./ko/translation.json";
import cn from "./cn/translation.json";
import { getCookie } from 'utils/cookie';
import Locale from 'store/lo.json';

const userLanguage = (()=>{
  let path = window.location?.pathname?.split("/");
  if (path[0] === 'en' || path[1] === 'en') {
    return "en";
  } else if (path[0] === 'ko' || path[1] === 'ko') {
    return "ko";
  } else if (path[0] === 'cn' || path[1] === 'cn') {
    return "cn";
  }
  if (getCookie('userCookie') === "true") {
    return getCookie('userCountry') || Locale;
  } else {
    return Locale
  }
})()
const resources = {
  en: {
    translation: en
  },
  ko: {
    translation: ko
  },
  cn: {
    translation: cn
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: userLanguage, // 기본 설정 언어
    fallbackLng: 'ko', // 번역 파일에서 찾을 수 없는 경우 기본 언어
    debug: false,
    defaultNS: 'translation',
    ns: 'translation',
    interpolation: {
      escapeValue: true
    }
    // keySeparator: false,
    // interpolation: {
    //   escapeValue: false,
    //   alwaysFormat: true,
    //   format(value, format, lng) {
    //     if (format === 'uppercase') return value.toUpperCase();
    //     // interpolation 되는 값이 number로 들어올 때, 언어 설정에 맞는 locale string으로 변환해서 반환
    //     if (typeof value === 'number') return value.toLocaleString(lng);
    //     return value;
    //   },
    // },
  });

export default i18n;